import { withStyles } from "tss-react/mui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSack } from "@fortawesome/pro-solid-svg-icons/faSack";
import { FreeBreakfast, ShoppingBasket } from "@mui/icons-material";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import rapportenStyle from "../../assets/jss/material-dashboard-pro-react/views/rapportenStyle";
import Card from "../../components/Card/Card";
import CardFooter from "../../components/Card/CardFooter";
import CardHeader from "../../components/Card/CardHeader";
import CardIcon from "../../components/Card/CardIcon";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import * as actions from "../../store/actions";
import { formatValuta } from "../../utils";
import Filters from "../Rapporten/Components/Filters";
import TranslationWrapper from "../../components/TranslationWrapper/TranslationWrapper.tsx";
import { toast } from "react-toastify";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { format } from "date-fns";

class Index extends React.Component {
  state = {
    order_items: [],
    order_items_totals: {
      total_item_count: 0,
      total_item_price: 0,
    },
    report_orders: {
      totalOrdersWithDrinks: 0,
      totalOrdersWithFood: 0,
      totalPaidItems: 0,
      totalPaidOrders: 0,
      totalSmsCount: 0,
      totalUnPaidItems: 0,
      valuePaid: 0,
      valueUnPaid: 0,
      totalUnPaidOrders: 0,
    },
    filtersActive: false,
  };

  currentReqeust;

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is.
     */
    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }
  }

  getBiData = (filterData) => {
    let filtersActive = false;

    if (!filterData.eind_datum || !filterData.start_datum) {
      return;
    }

    let data = {
      vestiging_ids:
        filterData.vestiging_ids.length == 1 && filterData.vestiging_ids.includes("all")
          ? []
          : filterData.vestiging_ids,
      item_source_type_list:
        filterData.item_source_type_list.length == 1 && filterData.item_source_type_list.includes("all")
          ? []
          : filterData.item_source_type_list,
      item_type_list:
        filterData.item_type_list.length == 1 && filterData.item_type_list.includes("all")
          ? []
          : filterData.item_type_list,
      item_names_list:
        filterData.item_names_list.length == 1 && filterData.item_names_list.includes("all")
          ? []
          : filterData.item_names_list,
      start_datum: format(new Date(filterData.start_datum), "yyyy-M-d HH:mm:ss"),
      eind_datum: format(new Date(filterData.eind_datum), "yyyy-M-d HH:mm:ss"),
    };

    if (data.item_source_type_list.length > 0 || data.item_type_list.length > 0) {
      filtersActive = true;
    }

    if (data.vestiging_ids.length > 0) {
      toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);
      if (this.currentReqeust !== undefined) {
        this.currentReqeust.cancel();
      }

      const CancelToken = axios.CancelToken;
      this.currentReqeust = CancelToken.source();
      let cancelToken = this.currentReqeust.token;

      axios
        .post("core/bi/get_data", data, {
          cancelToken: cancelToken,
        })
        .then((response) => {
          this.setState({ ...this.state, ...response.data.data, filtersActive: filtersActive });
        })
        .catch((error) => {
          /**
           * Alleen niet CANCEL errors afvangen
           */
          if (!error.__CANCEL__) {
            toast.error(
              <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
            );
          }
        });
    } else {
      toast.warning(
        <TranslationWrapper tDefault={"Please make a salesarea selection"} tKey={"global.salesareaselection"} />
      );
    }
  };

  render() {
    const { classes } = this.props;
    const COLORS = ["#b3b300", "#b37400", "#9d4e15", "#b30000", "#cc0022", "#b300b3", "#6918b4", "#0000b3", "#00b300"];

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Business Intelligence"} tKey={"bi.pageTitle"} />} />
        <Filters
          onFilterChange={this.getBiData}
          showBiFilters
          showEndDateDate
          showSaveButton
          showStartDateDate
          showVestigingen
        />
        <GridContainer>
          <GridItem lg={12} md={12} sm={12} xs={12}>
            <GridContainer>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <ShoppingBasket />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {parseInt(this.state.report_orders.totalPaidOrders) +
                        parseInt(this.state.report_orders.totalUnPaidOrders)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Order over the period"}
                        tKey={"rapportages.rapporten.bestellingen.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(
                        parseFloat(this.state.report_orders.valuePaid) +
                          parseFloat(this.state.report_orders.valueUnPaid)
                      )}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper tDefault={"Turnover over the period"} tKey={"rapportages.bi.omzet.periode"} />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FreeBreakfast />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {parseInt(this.state.report_orders.totalUnPaidItems) +
                        parseInt(this.state.report_orders.totalPaidItems)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Total products over the period"}
                        tKey={"rapportages.bi.producten.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(
                        (parseFloat(this.state.report_orders.valuePaid) +
                          parseFloat(this.state.report_orders.valueUnPaid)) /
                          (parseInt(this.state.report_orders.totalPaidOrders) +
                            parseInt(this.state.report_orders.totalUnPaidOrders))
                      )}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Gemiddelde bestelwaarde"}
                        tKey={"rapportages.bi.bestelwaarde.gemiddelde"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem lg={12} md={12} sm={12} xs={12}>
            <GridContainer>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <ShoppingBasket />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {parseInt(this.state.report_orders.totalOrdersWithDrinks)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Total order with drinks"}
                        tKey={"rapportages.bi.bestellingen.drinks"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {parseInt(this.state.report_orders.totalOrdersWithFood)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper tDefault={"Total orders with food"} tKey={"rapportages.bi.omzet.food"} />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>
          </GridItem>
          {this.state.filtersActive ? (
            <GridItem lg={12} md={12} sm={12} xs={12}>
              <GridContainer>
                <GridItem lg={3} md={6} sm={6} xs={12}>
                  <Card>
                    <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                      <CardIcon color={"primary"}>
                        <ShoppingBasket />
                      </CardIcon>
                      <h3
                        className={classes.cardTitle}
                        style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                      >
                        {parseInt(this.state.order_items_totals.total_item_count)}
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <TranslationWrapper
                          tDefault={"Total items in selection"}
                          tKey={"rapportages.bi.itemsselection"}
                        />
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>
                <GridItem lg={3} md={6} sm={6} xs={12}>
                  <Card>
                    <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                      <CardIcon color={"primary"}>
                        <FontAwesomeIcon icon={faSack} />
                      </CardIcon>
                      <h3
                        className={classes.cardTitle}
                        style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                      >
                        {formatValuta(parseFloat(this.state.order_items_totals.total_item_price))}
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <TranslationWrapper
                          tDefault={"Turnover in selection"}
                          tKey={"rapportages.bi.turnoverselection"}
                        />
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>
                <GridItem lg={3} md={6} sm={6} xs={12}>
                  <Card>
                    <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                      <CardIcon color={"primary"}>
                        <FontAwesomeIcon icon={faSack} />
                      </CardIcon>
                      <h3
                        className={classes.cardTitle}
                        style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                      >
                        {parseFloat(
                          (100 /
                            (parseFloat(this.state.report_orders.valuePaid) +
                              parseFloat(this.state.report_orders.valueUnPaid))) *
                            parseInt(this.state.order_items_totals.total_item_price)
                        ).toFixed(2)}{" "}
                        %
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <TranslationWrapper
                          tDefault={"Percentage of total turnover"}
                          tKey={"rapportages.bi.percentagetotalturnover"}
                        />
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>
                <GridItem lg={3} md={6} sm={6} xs={12}>
                  <Card>
                    <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                      <CardIcon color={"primary"}>
                        <FontAwesomeIcon icon={faSack} />
                      </CardIcon>
                      <h3
                        className={classes.cardTitle}
                        style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                      >
                        {parseFloat(
                          (100 /
                            (parseFloat(this.state.report_orders.totalPaidItems) +
                              parseFloat(this.state.report_orders.totalUnPaidItems))) *
                            parseInt(this.state.order_items_totals.total_item_count)
                        ).toFixed(2)}{" "}
                        %
                      </h3>
                    </CardHeader>
                    <CardFooter stats>
                      <div className={classes.stats}>
                        <TranslationWrapper
                          tDefault={"Percentage of total items"}
                          tKey={"rapportages.bi.percentagetotalitems"}
                        />
                      </div>
                    </CardFooter>
                  </Card>
                </GridItem>
              </GridContainer>
            </GridItem>
          ) : null}
        </GridContainer>
        <table style={{ width: "100%" }}>
          <tr style={{ fontWeight: "bold" }}>
            <td>Name</td>
            <td style={{ textAlign: "right" }}>Price</td>
            <td style={{ textAlign: "right" }}>Count</td>
            <td style={{ textAlign: "right" }}>Total</td>
            <td style={{ textAlign: "right" }}>Position</td>
            <td style={{ textAlign: "right" }}>Type</td>
            <td style={{ textAlign: "right" }}>Source type</td>
            <td style={{ textAlign: "right" }}>% on total order items</td>
            <td style={{ textAlign: "right" }}>% on selected items</td>
          </tr>
          {this.state.order_items.map((item, idx) => {
            return (
              <tr
                key={"order_items" + idx}
                style={{ borderWidth: "0px 2px 0px 2px", borderStyle: "solid", borderColor: "#000000" }}
              >
                <td>
                  <b>{item.item_name}</b>
                </td>
                <td style={{ textAlign: "right" }}>{formatValuta(item.item_price)}</td>
                <td style={{ textAlign: "right" }}>{item.total_item_count}</td>
                <td style={{ textAlign: "right" }}>
                  <b>{formatValuta(item.total_item_price)}</b>
                </td>
                <td style={{ textAlign: "right" }}>{item.item_position}</td>
                <td style={{ textAlign: "right" }}>{item.item_type}</td>
                <td style={{ textAlign: "right" }}>{item.item_source_type}</td>
                <td style={{ textAlign: "right" }}>
                  {parseFloat(
                    (100 /
                      (parseInt(this.state.report_orders.totalUnPaidItems) +
                        parseInt(this.state.report_orders.totalPaidItems))) *
                      item.total_item_count
                  ).toFixed(2)}{" "}
                  %
                </td>
                <td style={{ textAlign: "right" }}>
                  {parseFloat(
                    (100 / parseInt(this.state.order_items_totals.total_item_count)) * item.total_item_count
                  ).toFixed(2)}{" "}
                  %
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(Index, rapportenStyle));
